import React from 'react';
import MetricCard from './MetricCard';
import { getGenderBreakdown } from '@/utils/genderAnalytics';

const CandidateMetrics = ({ dashboardData }) => {
  // Using API data for total candidates with better fallback handling
  const metrics = {
    total: dashboardData?.total_candidates ?? 0,
    disabilities: {
      percentage: Math.round(dashboardData?.field_data?.Disability?.yes_percentage || 0),
    },
    sms: dashboardData?.sms_data?.average_sms_score || 0,
  };

  const genderBreakdown = getGenderBreakdown(dashboardData?.field_data?.Gender);

  // Check if SMS is enabled in dashboard fields
  const isSmsEnabled = dashboardData?.dashboard_fields?.[0]?.sms || false;

  // Check if total candidates score is enabled
  const isTotalCandidatesEnabled =
    dashboardData?.dashboard_fields?.[0]?.extra_settings?.[0]?.total_candidates_score || false;

  return (
    <div className="grid grid-cols-3 gap-4">
      {isTotalCandidatesEnabled && (
        <MetricCard
          title="Total Candidates"
          value={metrics.total || '0'}
        />
      )}

      {!!dashboardData?.dashboard_fields?.[0]?.fields?.find(
        (field) =>
          field.label?.toLowerCase() === 'gender' &&
          field.isChecked &&
          (field.visualization_type === 'card' || !field.visualization_type)
      ) &&
        genderBreakdown.map((item) => (
          <MetricCard
            key={item.key}
            title={`${item.label} Candidates`}
            value={`${item.percentage}%`}
          />
        ))}

      {!!dashboardData?.dashboard_fields?.[0]?.fields?.find(
        (field) =>
          field.label?.toLowerCase() === 'disability' &&
          field.isChecked &&
          (field.visualization_type === 'card' || !field.visualization_type)
      ) && (
        <MetricCard
          title="With Disabilities"
          value={`${metrics.disabilities.percentage}%`}
          iconColor="text-purple-500"
        />
      )}
      {!!isSmsEnabled && (
        <MetricCard
          title="Social Mobility Scores"
          value={`${Math.round(metrics.sms)}%`}
          iconColor="text-green-500"
        />
      )}
    </div>
  );
};

export default CandidateMetrics;
